import { CardModel, LinkModel } from '@flocasts/experience-service-types'
import { getAnalytics } from '../shared/experience.utility'

export const ARTICLE_SLUG_ROUTE_PARAM = 'article-slug'

export interface ArticleSubsetModel {
  contentItem: {
    slug_uri: string
    premium: boolean
    preview_text: string
    asset_url: string
    publish_start_date: string | null
    title: string
  }
  analytics: AnalyticsSubsetModel
}

interface AnalyticsSubsetModel {
  is_premium: boolean
  name: string
  node_id: number
  primary_association_id: number
  primary_association_title: string
}

export const convertArticleToCardModel = (article: ArticleSubsetModel): CardModel => {
  return {
    action: getAction(article.contentItem.slug_uri, article.analytics),
    description: article.contentItem.preview_text,
    previewVideoMetadata: null,
    iconImage: null,
    id: getId(article.analytics.node_id),
    label1: null,
    previewImage: {
      url: article.contentItem.asset_url,
      type: 'Card',
      id: 'null',
      altText: null,
      style: 'standard',
      zoom: 1
    },
    showPlayIcon: false,
    style: 'large-card',
    subtitle1: null,
    subtitle1Parts: {
      displayDate: article.contentItem.publish_start_date,
      type: 'node-detail-parts',
      isPremium: article.contentItem.premium,
      authorName: null
    },
    subtitle2: null,
    title: article.contentItem.title,
    type: 'Card'
  }
}

export const getId = (nodeId: number): string => {
  return nodeId ? nodeId.toString() : 'non-unique-id'
}

export const getAction = (url: string, analytics: AnalyticsSubsetModel): LinkModel => {
  return {
    type: 'link',
    screenType: 'unknown',
    id: getId(analytics.node_id),
    title: null,
    url,
    style: 'open',
    nextStyle: null,
    nodeId: analytics.node_id,
    nodeType: 'article',
    analytics: getAnalytics(
      analytics.is_premium,
      analytics.node_id,
      'article',
      analytics.name,
      analytics.primary_association_id,
      analytics.primary_association_title
    ),
    shareUrl: null,
    state: null,
    apiCall: null,
    mergeParams: null,
    contentMetadata: null,
    asset: null,
    secondaryAsset: null,
    target: null
  }
}
